import React from 'react';
import * as IoC from 'typescript-ioc';
import { FormattedMessage } from 'react-intl';
import { IAlertsService } from '../../../../infrastructure/alerts';
import { AlertErrorMessage } from './types/alert/alert-error-message';
import { AlertWarningMessage } from './types/alert/alert-warning-message';
import { IErrorParsing } from '../../../../infrastructure/error-parsing';

const alertServerError = (title: string | object, message: string | object): string => {
    const alertsService = IoC.Container.get<IAlertsService>(IAlertsService);
    return alertsService.alert({
        message: <AlertErrorMessage title={title} message={message} />,
        okButtonProps: {
            text: <FormattedMessage id='oe.common.ok' description='Button text' defaultMessage='Ok' />,
        },
    });
};

const alertServerWarning = (title: string | object, message: string | object): string => {
    const alertsService = IoC.Container.get<IAlertsService>(IAlertsService);
    return alertsService.alert({
        message: <AlertWarningMessage title={title} message={message} />,
        okButtonProps: {
            text: <FormattedMessage id='oe.common.ok' description='Button text' defaultMessage='Ok' />,
        },
    });
};

interface INotificationOptions {
    statusCode?: number;
    alignment?: string;
    withCloseIcon?: boolean;
    isRelatedToEvent?: boolean;
    noStatusIcon?: boolean;
}

const showNotification = (
    message: string | JSX.Element,
    options: INotificationOptions = {}
): string => {
    const alertsService = IoC.Container.get<IAlertsService>(IAlertsService);
    return alertsService.notification({
        message: message,
        ...options
    });
};

const closeNotification = (alertKey: string) => {
    const alertsService = IoC.Container.get<IAlertsService>(IAlertsService);
    alertsService.closeNotification(alertKey);
};

const closeEventNotifications = () => {
    const alertsService = IoC.Container.get<IAlertsService>(IAlertsService);
    alertsService.closeEventNotifications();
};

const handleApiException = (
    error: Error,
    title: string = 'Error',
    errorMessage: string = null,
) => {
    const errorParsingService = IoC.Container.get(IErrorParsing);
    const message = errorMessage ?? errorParsingService.extractMessage(error);
    alertServerError(title, message);
};

export {
    alertServerError,
    alertServerWarning,
    showNotification,
    handleApiException,
    closeNotification,
    closeEventNotifications,
    INotificationOptions,
};
